(function () {
  var config = window.geoRedirectConfig;
  if (!config || !config.countries || !config.countries.length || !config.url) return;

  var EMEA_CODES = config.countries;
  var EMEA_URL = config.url;

  function checkAndRedirect(code) {
    if (code && EMEA_CODES.indexOf(code.toUpperCase()) !== -1) {
      window.location.assign(EMEA_URL);
      return true;
    }

    return false;
  }

  // Shopify country detection
  var root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    '/';

  fetch(root + 'browsing_context_suggestions.json', {
    credentials: 'same-origin',
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      // Primary: detected country
      var code =
        data.detected_values &&
        data.detected_values.country &&
        data.detected_values.country.handle;

      if (checkAndRedirect(code)) return;

      // Fallback: check suggestions array
      var suggestions =
        data.suggestions ||
        data.browsing_context_suggestions ||
        data.country_suggestions ||
        [];

      for (var i = 0; i < suggestions.length; i++) {
        var s = suggestions[i];

        var countryCode =
          s.country_code || s.countryCode || s.country_iso_code || '';

        if (checkAndRedirect(countryCode)) return;
      }
    })
    .catch(function () {
      // Final fallback: IP-based country detection
      fetch('https://get.geojs.io/v1/ip/geo.json')
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          checkAndRedirect(data.country_code);
        })
        .catch(function () {
          // Do nothing if country detection fails
        });
    });
})();
